/** Cruz vermelha de emergência — hospital e ambulância, giradas/escaladas por quem chama. */
export function Cruz3D({ cor = '#dc2626' }: { cor?: string }) {
  return (
    <group>
      <mesh castShadow>
        <boxGeometry args={[0.9, 0.3, 0.08]} />
        <meshStandardMaterial color={cor} />
      </mesh>
      <mesh castShadow>
        <boxGeometry args={[0.3, 0.9, 0.08]} />
        <meshStandardMaterial color={cor} />
      </mesh>
    </group>
  )
}
